var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.rerender
        ? _c(
            "j-xlsx-table",
            {
              ref: "preview",
              attrs: {
                accept: _vm.fileTypes,
                "required-columns": _vm.required_columns[_vm.type]
              },
              on: {
                onClickDownload: _vm.onClickDownload,
                "get-files": _vm.setFiles,
                "on-select-file": _vm.handleSelectedFile
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.placeholder) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "myModalRef",
          staticClass: "mod-form",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c("h3", [_vm._v("Import Previews")]),
          _vm._v(" "),
          _c(
            "div",
            {},
            [
              _vm.tableData !== null
                ? _c(
                    "j-table-preview",
                    {
                      attrs: {
                        "invalid-header": _vm.invalidHeader,
                        columns: _vm.columns,
                        "table-data": _vm.tableData
                      },
                      on: { importData: _vm.importData }
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn grey",
                          on: { click: _vm.closeTable }
                        },
                        [_vm._v("\n          Close\n        ")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c02dda7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c02dda7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/import/buttons/jImportEmployeeButton.vue
// module id = null
// module chunks = 